import React from 'react';
import { useSelector } from 'react-redux';

export default function useTeacherMedium() {

    const teacherProfileInformation = useSelector((state: any) => state.teacher.teacherSchool);
    const medium: number = teacherProfileInformation?.school?.medium?.id;

    return medium;
}
